export default "__VITE_ASSET__BeWyQDZ7__"